<!--
Nutrition summary for a meal plan: fetches the server-side aggregation (computed on
read, same habit as Meal_plan_checklist.vue) and renders a plan-wide total plus a
per-day breakdown.

<MealPlanNutrition :plan_id="plan.id" />
-->
<template>
    <div class="plan_nutrition">
        <p class="error_text" v-if="error">{{ error }}</p>
        <template v-if="!error && loaded">
            <NutritionFacts
                :totals="grand_total"
                :incomplete="entries_with_unknown.length > 0"
                :basis-label="$t('nutrition.plan_total')"
            />
            <div class="by_day" v-if="by_day.length > 1">
                <h4>{{ $t('nutrition.by_day') }}</h4>
                <div class="day_row" v-for="day in by_day" :key="day.date">
                    <span class="day_date">{{ day.date }}</span>
                    <span class="day_calories">{{ day.total.calories }} kcal</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NutritionFacts from './Nutrition_facts.vue';

export default {
    name: "MealPlanNutrition",
    components: {
        NutritionFacts
    },
    props: [
        'plan_id'
    ],
    data() {
        return {
            grand_total: null,
            by_day: [],
            missing_recipes: [],
            entries_with_unknown: [],
            loaded: false,
            error: null
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        })
    },
    mounted() {
        this.getNutrition();
    },
    methods: {
        getNutrition() {
            fetch(process.env.VUE_APP_API + `/mealplans/` + this.plan_id + `/nutrition`, {
                headers: {
                    "TOKEN": JSON.stringify(this.user.data.token)
                }
            }).then(res => res.json())
              .then(res => {
                  this.loaded = true;
                  if (res.error) {
                      this.error = res.error;
                  } else {
                      this.grand_total = res.nutrition.grand_total;
                      this.by_day = res.nutrition.by_day;
                      this.missing_recipes = res.nutrition.missing_recipes;
                      this.entries_with_unknown = res.nutrition.entries_with_unknown;
                  }
              });
        }
    }
}
</script>

<style scoped>
.plan_nutrition {
    text-align: left;
}
.by_day {
    margin-top: 1rem;
}
.by_day h4 {
    font-size: 0.9rem;
    color: var(--color-grey-2);
}
.day_row {
    display: flex;
    justify-content: space-between;
    max-width: 260px;
    padding: 0.2rem 0;
    border-bottom: var(--line-dashed);
}
.day_date {
    color: var(--color-grey-2);
}
.error_text {
    color: var(--color-grey-2);
}
</style>
